const dashboardMockData = {
  today: {
    summary: {
      totalTransactions: 1248,
      totalTickets: 2874
    },
    hourly: [
      { label: '06', transactions: 48, tickets: 92 },
      { label: '07', transactions: 78, tickets: 166 },
      { label: '08', transactions: 116, tickets: 248 },
      { label: '09', transactions: 98, tickets: 214 },
      { label: '10', transactions: 72, tickets: 150 },
      { label: '11', transactions: 68, tickets: 141 },
      { label: '12', transactions: 81, tickets: 172 },
      { label: '13', transactions: 76, tickets: 160 },
      { label: '14', transactions: 84, tickets: 179 },
      { label: '15', transactions: 95, tickets: 205 },
      { label: '16', transactions: 109, tickets: 250 },
      { label: '17', transactions: 124, tickets: 302 }
    ],
    origin: [
      { label: 'BHI', value: 442 },
      { label: 'DKA', value: 399 },
      { label: 'STB', value: 285 },
      { label: 'BLM', value: 233 },
      { label: 'FTM', value: 201 }
    ],
    destination: [
      { label: 'DKA', value: 418 },
      { label: 'BHI', value: 372 },
      { label: 'BLM', value: 321 },
      { label: 'LBB', value: 266 },
      { label: 'ASN', value: 208 }
    ],
    partners: [
      { label: 'Chatbot', value: 564, color: '#0c53b7' },
      { label: 'MRTJ App', value: 382, color: '#00a76f' },
      { label: 'Web Portal', value: 202, color: '#f59e0b' },
      { label: 'Kiosk', value: 100, color: '#ef4444' }
    ]
  },
  this_week: {
    summary: {
      totalTransactions: 8432,
      totalTickets: 19345
    },
    hourly: [
      { label: '06', transactions: 362, tickets: 804 },
      { label: '07', transactions: 540, tickets: 1215 },
      { label: '08', transactions: 688, tickets: 1551 },
      { label: '09', transactions: 594, tickets: 1322 },
      { label: '10', transactions: 451, tickets: 978 },
      { label: '11', transactions: 432, tickets: 930 },
      { label: '12', transactions: 489, tickets: 1044 },
      { label: '13', transactions: 466, tickets: 995 },
      { label: '14', transactions: 478, tickets: 1028 },
      { label: '15', transactions: 521, tickets: 1134 },
      { label: '16', transactions: 587, tickets: 1318 },
      { label: '17', transactions: 644, tickets: 1488 }
    ],
    origin: [
      { label: 'BHI', value: 2910 },
      { label: 'DKA', value: 2654 },
      { label: 'STB', value: 1858 },
      { label: 'BLM', value: 1567 },
      { label: 'FTM', value: 1432 }
    ],
    destination: [
      { label: 'DKA', value: 2818 },
      { label: 'BHI', value: 2416 },
      { label: 'BLM', value: 2269 },
      { label: 'LBB', value: 1845 },
      { label: 'ASN', value: 1662 }
    ],
    partners: [
      { label: 'Chatbot', value: 3735, color: '#0c53b7' },
      { label: 'MRTJ App', value: 2579, color: '#00a76f' },
      { label: 'Web Portal', value: 1316, color: '#f59e0b' },
      { label: 'Kiosk', value: 802, color: '#ef4444' }
    ]
  },
  this_month: {
    summary: {
      totalTransactions: 34192,
      totalTickets: 78804
    },
    hourly: [
      { label: '06', transactions: 1542, tickets: 3588 },
      { label: '07', transactions: 2231, tickets: 5147 },
      { label: '08', transactions: 2867, tickets: 6653 },
      { label: '09', transactions: 2488, tickets: 5781 },
      { label: '10', transactions: 1964, tickets: 4462 },
      { label: '11', transactions: 1872, tickets: 4229 },
      { label: '12', transactions: 2016, tickets: 4564 },
      { label: '13', transactions: 1943, tickets: 4381 },
      { label: '14', transactions: 2050, tickets: 4616 },
      { label: '15', transactions: 2218, tickets: 5032 },
      { label: '16', transactions: 2494, tickets: 5775 },
      { label: '17', transactions: 2707, tickets: 6576 }
    ],
    origin: [
      { label: 'BHI', value: 11642 },
      { label: 'DKA', value: 11024 },
      { label: 'STB', value: 8240 },
      { label: 'BLM', value: 6598 },
      { label: 'FTM', value: 6147 }
    ],
    destination: [
      { label: 'DKA', value: 11888 },
      { label: 'BHI', value: 10472 },
      { label: 'BLM', value: 9276 },
      { label: 'LBB', value: 7164 },
      { label: 'ASN', value: 5881 }
    ],
    partners: [
      { label: 'Chatbot', value: 14584, color: '#0c53b7' },
      { label: 'MRTJ App', value: 10738, color: '#00a76f' },
      { label: 'Web Portal', value: 5402, color: '#f59e0b' },
      { label: 'Kiosk', value: 3468, color: '#ef4444' }
    ]
  }
};

export default dashboardMockData;
